/*
  Indice de defilement du tiroir mobile (#MenuDrawer).
  - Pose `has-scroll-fade` sur chaque `.drawer__scrollable` qui peut encore
    defiler vers le bas (pour le fondu CSS, en ::after sur la zone scrollable).
  - Pose `has-scroll-cue` sur le PARENT (panneau) et y injecte un chevron
    positionne en ABSOLU au bas du panneau. On evite `position: sticky` dans la
    zone scrollable car le theme y applique `scroll-snap-type: mandatory`, qui
    casse le sticky. Singleton : safe si injecte plusieurs fois.
*/
(function () {
  if (window.__mdbDrawerFade) return;
  window.__mdbDrawerFade = true;

  var THRESH = 4;

  function ensureCue(parent) {
    if (!parent || parent.querySelector(':scope > .drawer__scroll-cue')) return;
    var c = document.createElement('span');
    c.className = 'drawer__scroll-cue';
    c.setAttribute('aria-hidden', 'true');
    parent.appendChild(c);
  }

  function update(el) {
    if (!el || !el.classList) return;
    var d = document.getElementById('MenuDrawer');
    var parent = el.parentElement;
    ensureCue(parent);
    var scrollable = el.scrollHeight - el.clientHeight > THRESH;
    var atEnd = el.scrollTop + el.clientHeight >= el.scrollHeight - THRESH;
    // le menu de 1er niveau est masque quand un sous-menu est ouvert -> pas de chevron
    var isTop = el.classList.contains('drawer__menu');
    var submenuOpen = d && !!d.querySelector('details[open]');
    var show = scrollable && !atEnd && !(isTop && submenuOpen);
    el.classList.toggle('has-scroll-fade', show);
    if (parent) parent.classList.toggle('has-scroll-cue', show);
  }

  function refreshAll() {
    var d = document.getElementById('MenuDrawer');
    if (!d) return;
    var list = d.querySelectorAll('.drawer__scrollable');
    for (var i = 0; i < list.length; i++) update(list[i]);
  }

  var t;
  function refreshSoon() {
    clearTimeout(t);
    t = setTimeout(refreshAll, 120);
  }

  // Masquage au scroll (l'evenement scroll ne "bubble" pas -> capture)
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (el && el.classList && el.classList.contains('drawer__scrollable')) update(el);
  }, true);

  // Re-verifie apres interactions / fin d'animation de panneau / resize
  document.addEventListener('click', refreshSoon, true);
  document.addEventListener('transitionend', function (e) {
    var c = e.target && e.target.classList;
    if (c && (c.contains('drawer__submenu') || c.contains('drawer__inner'))) refreshSoon();
  }, true);
  window.addEventListener('resize', refreshSoon);

  // Observe le contenu injecte a la demande (sous-menus via Section Rendering API)
  function start() {
    var d = document.getElementById('MenuDrawer');
    if (!d) { setTimeout(start, 600); return; }
    new MutationObserver(refreshSoon).observe(d, { childList: true, subtree: true });
    refreshAll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();